import React from "react"
import _ from "lodash"
import moment from "moment"
import styled from "@emotion/styled"

import { timestampNormalizer } from "../util"
import Audio from "../Audio/Audio"
import ButtonTemplate from "../ButtonTemplate/ButtonTemplate"
import File from "../File/File"
import Carousel from "../Carousel/Carousel"
import Image from "../Image/Image"
import Animation from "../Animation/Animation"
import List from "../List/List"
import Media from "../Media/Media"
import Payload from "../Payload/Payload"
import QuickReplies from "../QuickReplies/QuickReplies"
import Text from "../Text/Text"
import Video from "../Video/Video"
import Misc from "../Misc/Misc"
import Raw from "../Raw/Raw"


const ProfilePic = styled.div`
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  box-sizing: border-box;
  background: white center center no-repeat url("${props => props.url}");
  background-size: contain;
  box-shadow: 1px 1px 8px 0 rgba(0,0,0,0.08);
  margin-right: 8px;
`


function renderMessage(message, onAction, options, color) {
  switch (message.type) {
    case "BUTTON":
      return (<ButtonTemplate data={message.data} onAction={onAction} color={color} />)
    case "FILE":
      return (<File data={message.data} color={color} />)
    case "VIDEO":
      return (<Video data={message.data} color={color} />)
    case "AUDIO":
    case "TEAMWORK_VOICE":
      return (<Audio data={message.data} color={color} />)
    case "IMAGE":
      return (<Image data={message.data} color={color} />)
    case "ANIMATION":
      return (<Animation data={message.data} color={color} />)
    case "ATTACHMENT":
    case "TEXT":
    case "QUICK_REPLIES":
      return (<Text data={message.data} color={color} />)
    case "LIST":
      return (<List data={message.data} onAction={onAction} color={color} />)
    case "CAROUSEL":
      return (<Carousel data={message.data} onAction={onAction} itemWidth={options.carouselItemWidth} color={color} />)
    case "MEDIA":
      return (<Media data={message.data} onAction={onAction} color={color} />)
    case "PAYLOAD":
      return (<Payload data={message.data} color={color} />)
    case "MISC":
      return (<Misc data={message.data} color={color} />)
    default:
      return (<Raw data={message} />)
  }
}

function renderQuickReplies(message, onAction, readOnly, isLast, themeColor) {
  if (message.type === "QUICK_REPLIES" || _.get(message, "data.quickReplies.length") > 0) {
    let showOptions = false
    if (readOnly) {
      showOptions = true
    } else if (isLast) {
      showOptions = true
    }
    return (
      <QuickReplies
        data={message.data}
        shouldShowQuickReplies={showOptions}
        onAction={onAction}
        color={themeColor}
      />
    )
  }
  return null
}

class Bot extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contentWidth: 300,
      rowAlignItems: "flex-start"
    }
  }
  componentDidMount() {
    if (this.content) {
      const width = this.content.offsetWidth
      if (width < this.state.contentWidth) {
        this.setState({
          contentWidth: width
        })
      }
    }
    setTimeout(() => {
      if (this.row) {
        if (this.row.offsetHeight <= 68) {
          this.setState({
            rowAlignItems: "center"
          })
        }
      }
    }, 0)
  }

  render() {
    const {
      message,
      profilePic,
      onAction,
      readOnly,
      isLast,
      noProfilePic,
      noTimeDisplay,
      themeColor,
    } = this.props

    const rowStyle = {
      alignItems: this.state.rowAlignItems
    }
    
    return (
      <div
        ref={(c) => { this.row = c }}
        style={rowStyle}
        className="bot row"
      >
        {noProfilePic ?
          null
          :
          <ProfilePic
            url={profilePic}
            color={themeColor}
          />
        }
        <div className="content-info">
          <div
            className="content"
            ref={(c) => { this.content = c }}
          >

            {renderMessage(message, onAction, { carouselItemWidth: this.state.contentWidth }, themeColor)}
            {renderQuickReplies(message, onAction, readOnly, isLast, themeColor)}
          </div>
          {noTimeDisplay ?
            null
            :
            <div className="time-display">
              {timestampNormalizer(message.timestamp) ? moment(timestampNormalizer(message.timestamp)).format("HH:mm") : null}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default Bot
